export default __webpack_public_path__ + "static/media/bw_photos_tikal-1.a1878725.jpg";